import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=5a03f8ae&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"
import style0 from "./Customer.vue?vue&type=style&index=0&id=5a03f8ae&lang=scss&scoped=true&"
import style1 from "./Customer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03f8ae",
  null
  
)

export default component.exports